import { Route, Routes, useLocation } from "react-router-dom";
import AboutUs from "./AboutUs";
import BackToTop from "./components/BackToTop";
import Footer from "./components/Footer";
import HeaderOne from "./components/Header/HeaderOne";
import HeaderTwo from "./components/Header/HeaderTwo";
import ProductDetail from "./components/ProductDetail";
import ScrollToTop from "./components/ScrollToTop";
import ContactUs from "./ContactUs";
import Home from "./Home";
import AddBrand from "./pages/Brand/AddBrand";
import ViewBrands from "./pages/Brand/ViewBrands";
import Category from "./pages/Category";
import AddCategory from "./pages/Category/AddCategory";
import ViewCategories from "./pages/Category/ViewCategories";
import ContactAdmin from "./pages/ContactAdmin";
import Dashboard from "./pages/Dashboard";
import AdminStatsDetail from "./pages/Dashboard/StatsDetail";
import Login from "./pages/Login";
import NotFound404 from "./pages/NotFound404";
import AddProduct from "./pages/Product/AddProduct";
import ImportProducts from "./pages/Product/ImportProducts";
import ViewProducts from "./pages/Product/ViewProducts";
import Profile from "./pages/Profile";
import StatsDetail from "./pages/StatsDetail";
import Users from "./pages/Users";
import PrivacyPolicy from "./PrivacyPolicy";
import ProtectedRoute from "./ProtectedRoute";
import ReturnRefundPolicy from "./ReturnRefundPolicy";
import ShippingPolicy from "./ShippingPolicy";
import Shop from "./Shop";
import TermsAndConditions from "./TermsAndConditions";
import WarrantyInformation from "./WarrantyInformation";

import { useCookies } from "react-cookie";
import CookiesComp from "./components/CookiesComp";

// Admin Pages

function App() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  // Hide header and footer on login and admin dashboard pages only
  const isLoginPage = location.pathname === "/server-login-584";
  const adminPaths = [
    "/dashboard",
    "/product/add",
    "/product/view",
    "/product/import",
    "/category/add",
    "/category/view",
    "/brand/add",
    "/brand/view",
    "/profile",
    "/contact/messages",
    "/users",
    "/dashboard/data-detail",
  ];
  const isDashboardPage = adminPaths.some((path) =>
    location.pathname.startsWith(path)
  );
  const showHeaderFooter = !isLoginPage && !isDashboardPage;

  const [cookies] = useCookies(["cookieConsent"]);
  return (
    <>
      <ScrollToTop />
      {showHeaderFooter && (isHome ? <HeaderOne /> : <HeaderTwo />)}
      {/* <HeaderTwo /> */}
      <Routes>
        {/* Frontend Routes */}
        <Route path="*" element={<NotFound404 />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/refund-and-returns-policy"
          element={<ReturnRefundPolicy />}
        />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/warranty-information" element={<WarrantyInformation />} />

        <Route path="/shop" element={<Shop />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:slug" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/data-detail" element={<StatsDetail />} />
        {/* Admin Routes */}
        <Route path="/server-login-584" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/add"
          element={
            <ProtectedRoute permission="product_add">
              <AddProduct />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/view"
          element={
            <ProtectedRoute permission="product_view">
              <ViewProducts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product/import"
          element={
            <ProtectedRoute permission="product_import">
              <ImportProducts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/category/add"
          element={
            <ProtectedRoute permission="category_add">
              <AddCategory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/view"
          element={
            <ProtectedRoute permission="category_view">
              <ViewCategories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand/add"
          element={
            <ProtectedRoute permission="brand_add">
              <AddBrand />
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand/view"
          element={
            <ProtectedRoute permission="brand_view">
              <ViewBrands />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact/messages"
          element={
            <ProtectedRoute permission="contact_access">
              <ContactAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute permission="user_manage">
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/data-detail"
          element={
            <ProtectedRoute>
              <AdminStatsDetail />
            </ProtectedRoute>
          }
        />
      </Routes>

      {showHeaderFooter && <Footer />}
      <BackToTop />

      {/* Cookie Banner */}
      <CookiesComp />
    </>
  );
}

export default App;
